import { SourceType } from '@ui/__generated__/graphql'

export const needsDatableApiKey = (sourceType: SourceType) => {
  // DD / NR have their own API keys
  return ![SourceType.Datadog, SourceType.NewRelic].includes(sourceType)
}
